import createLocationModel from '../lib/create_location_model';

export default createLocationModel({
  modelName: 'LookupApi',
  properties: {},

  statics: {
    breadcrumb: 'Customer Lookup',
  },
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/location/integrations/lookup_api.js